export default __webpack_public_path__ + "static/media/play_audio.eea1fae0.png";